export class LenderConfiguration {
    ClientId!: number;
    LenderName!: string;
    TwilioIntegrationId!: number;
    UniqueId!: string;
    AccountSid!: string;
    MessagingServiceSid!: string;
    AuthToken!: string;
    LenderOutboundWebhookUrl!: string;
    LenderInboundWebhookUrl!: string;
}
